export default {
  'status.active': 'Active',
  'status.passive': 'Passive',
  'status.deleted': 'Deleted',
  'status.pendingEmailVerification': 'Waiting For Email Verification',
  'status.pendingInvitation': 'Pending Invitation',
  'status.unknown': 'Unknown',
};
